module.exports = __webpack_public_path__ + "img/link.138a08bf.svg";